<!-- 填空题 -->
<template>
  <div class="form-fillblank">
    <FormTitle
      :required="Boolean(data.is_must_answer)"
      :title="data.title"
      :desc="data.title_details"
    />
    <!-- 填空 - 任意 -->
    <div class="every-form-text" :class="{'single-line': options.lines === 1}" v-if="inputTypeMappingGraph.common.includes(options.type)">
      <gkFormText
        :field="field"
        :rule="isValidity ? rules : []"
        :placeholder="data.tips"
        :type="options.lines > 1 ? 'textarea' : 'text'"
        :validity="isValidity"
        :length="options.lines > 1 ? 1500 : 100"
        v-model="inputValue"
        size="normal"
        color="gray"
      >
        <div v-if="options.lines > 1" class="word-count" slot="end">{{inputValue.length}} / 1500 字</div>
      </gkFormText>
    </div>
    <!-- 只能输入数字 -->
    <div class="number-form-text"  v-if="inputTypeMappingGraph.number.includes(options.type)">
      <gkFormText
        :field="field"
        :rule="isValidity ? rules : []"
        :customRule="{numberOnly: customRule.numberOnly}"
        :placeholder="data.tips"
        type="text"
        :validity="isValidity"
        :length="options.lines > 1 ? 1500 : 100"
        v-model="inputValue"
        size="normal"
        color="gray"
      >
      </gkFormText>
    </div>
    <!-- 填空 - 邮箱 -->
    <div class="email-form-text" v-if="inputTypeMappingGraph.email.includes(options.type)">
      <gkFormText
      :field="field"
      :rule="isValidity ? rules : []"
      :customRule="{cusEmail: customRule.cusEmail}"
      placeholder="请输入邮箱"
      :validity="isValidity"
      size="normal"
      color="gray"
      v-model="inputValue"
      />
    </div>

    <!-- 填空 - 手机号 -->
    <!-- 100111 需要验证短信 -->
    <template v-if="inputTypeMappingGraph.phone.includes(options.type)">
      <gkFormCustomGroup
        class="custom-group"
        :field="field"
        :rule="isValidity ? rules : []"
        :customRule="{phone: customRule.phone, specialPhone: customRule.specialPhone}"
        :validity="isValidity"
        v-model="phoneValue"
      >
        <div class="phone-form-text">
          <div class="area-num" :class="{focus: phoneFocus}" @click="countryOpen = true">
            <span>+ {{country}}</span>
          </div>

            <div class="phone-form-text-wrap" :class="{focus: phoneFocus}">
              <input
                type="text"
                :placeholder="options.tips"
                v-model="inputValue"
                @input="phoneInput"
                @focus="phoneFocus = true"
                @blur="saveTel"
              />
            </div>
          <div v-show="countryOpen">
            <div class='cover' @click="countryOpen = false"></div>
            <ul class="country-dropdown">
              <li v-for='(item, i) in phoneList' :key='i' :class="{active: item.code == country}" @click="selectCountry(item.code)">
                <span>{{item.cn}}</span>
                <p><span class='nw-add'>+</span>{{item.code}}</p>
              </li>
            </ul>
          </div>
        </div>
      </gkFormCustomGroup>
      <template v-if="inputTypeMappingGraph.phone_captcha.includes(options.type)">
        <div class="nvc-wrap">
          <div id="MessageNVC"></div>
        </div>
        <gkFormCustomGroup
            class="captcha-custom-group"
            field="captcha"
            :validity="isValidity"
            :rule="isValidity ? captchaRule : []"
            v-model="captchaValue"
            >
          <div class="captcha-wrap phone-form-text-wrap" :data-focus="captchaFocus">
            <input
              type="text"
              placeholder="短信验证码"
              class="captcha"
              :disabled="!phoneValue"
              :class="{disabled: !phoneValue}"
              @focus="captchaFocus = true"
              @blur="captchaFocus = false"
              @input="captchaInput"
              v-model="captchaValue"
            />
            <span class="send-btn"
              :class="[{
                disabled: !phoneValue || captchaSending
              }]"
              @click.stop="send"
            >
              {{captchaSending ? `${waitTime}s 后重新获取` : captchaSended ? '重新获取' : '获取验证码'}}
            </span>
          </div>
        </gkFormCustomGroup>
      </template>
    </template>
    <!-- 填空 - 日期 -->
    <div class="date-form-text" v-if="inputTypeMappingGraph.date.includes(options.type)">
      <gkFormCustomGroup
        :field="field"
        :rule="isValidity ? rules : []"
        :validity="isValidity"
        v-model="dateValue"
      >
        <template v-if="options.format === 1">
          <DatePicker
            type="datetime"
            transfer
            :editable="false"
            placeholder="请选择日期"
            format='yyyy/MM/dd hh:mm:ss'
            @on-change="getTime($event)"
            style="width: 100%"
          />
          <i class="iconfont date-icon">&#xe648;</i>
        </template>
        <template v-else>
          <DatePicker
            type="date"
            transfer
            :editable="false"
            placeholder="请选择日期"
            format='yyyy/MM/dd'
            @on-change="getTime($event)"
            style="width: 100%"
          />
          <i class="iconfont date-icon">&#xe648;</i>
        </template>
      </gkFormCustomGroup>
    </div>
    <template v-if="inputTypeMappingGraph.is_company_tianyancha(this.data.type, options.type)">
      <CompanyTianyanchaComponent :data="data" :value="inputValue" />
    </template>
    <template v-else>
      <address-component
        v-if="inputTypeMappingGraph.common_address.includes(options.type)"
        :data="data"
      />
      <user-info-address-component
        v-if="inputTypeMappingGraph.user_info_address.includes(options.type)"
        :data="data"
        :userFieldInfo="userFieldInfo"
      />
    </template>
  </div>

</template>
<script>
import {mapState} from 'vuex'
import VueTypes from 'vue-types'
import FormTitle from '@/components/FormTitle'
import gkFormCustomGroup from 'gkui/form/FormCustomGroup'
import gkFormText from 'gkui/form/FormText'
import utils from '../../../../utils'
import { $nvcEvent, initNvcMessage, showNC, resetNC } from '../../../../utils/nvc'
import { inputTypeMappingGraph } from '../const'
import EventService from '@/service/event.service'
import AddressComponent from './Address'
import UserInfoAddressComponent from './UserInfoAddress'
import CompanyTianyanchaComponent from './CompanyTianyancha'

export default {
  name: 'text-input',
  props: {
    data: VueTypes.object.def({}),
    userFieldInfo: VueTypes.object.def({})
  },
  components: {
    FormTitle,
    gkFormCustomGroup,
    gkFormText,
    AddressComponent,
    UserInfoAddressComponent,
    CompanyTianyanchaComponent
  },
  data () {
    return {
      inputTypeMappingGraph,
      inputValue: '',
      phoneValue: '',
      countryOpen: false,
      country: 86,
      cellphone: '',
      phoneFocus: false,
      dateValue: '',
      captchaValue: '',
      captchaFocus: false,
      captchaSending: false,
      captchaSended: false,
      waitTime: 60,
      nvcData: null
    }
  },
  watch: {
    userFieldInfo: {
      handler: function (newData, oldData) {
        try {
          // eslint-disable-next-line camelcase
          const extraInfo = this.data?.extra_info && JSON.parse(this.data.extra_info)
          if (!extraInfo) {
            return
          }
          // 如果后端返回的是数组
          if (Array.isArray(extraInfo)) {
            extraInfo.forEach(item => {
              const { user_attribute: key } = item
              if (key === 'country') {
                // backend may return country as array like ['86']
                // convert to number, but keep previous value if parsing fails
                const rawCountry = newData && newData['country'] && newData['country'][0]
                const parsed = parseInt(rawCountry, 10)
                this.country = Number.isNaN(parsed) ? this.country : parsed
                return
              }
              if (newData !== oldData && key && newData[key]) {
                const value = newData[key]
                if (value) {
                  // 回显时也要同步 cellphone 与 phoneValue，并写入本地缓存，
                  // 以保证与用户手动输入时一致的上送/校验行为
                  this.inputValue = value[0]
                  this.cellphone = value[0]
                  try {
                    // 保存至本地缓存，模拟 saveTel 的效果
                    utils.storage.set('tel', value[0])
                  } catch (err) {
                    // storage 失败不影响回显
                  }
                }
              }
            })
            this.phoneValue = `${this.country}-${this.inputValue}`
            return
          }
          // extraInfo 为对象时按原有逻辑处理
          const { user_attribute: key } = extraInfo
          if (newData !== oldData && key && newData[key]) {
            const value = newData[key]
            if (value) {
              this.inputValue = value[0]
            }
          }
        } catch (e) {
          console.log(e)
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState([
      'phoneList',
      'isMobile'
    ]),
    options () {
      return this.data.details.options[0]
    },
    rules () {
      let rule = []
      if (this.data.is_must_answer) {
        rule.push({
          required: this.tipLabel(this.options.type)
        })
      }

      if (this.inputTypeMappingGraph.number.includes(this.options.type)) {
        rule.push({'numberOnly': '仅支持填写数字'})
      }

      if (this.inputTypeMappingGraph.email.includes(this.options.type)) {
        rule.push({'cusEmail': '邮箱格式错误'})
      }
      if (this.inputTypeMappingGraph.phone.includes(this.options.type)) {
        if (this.country === 86) {
          rule.push({'phone': '手机号格式错误'})
        } else {
          rule.push({'specialPhone': '手机号格式错误'})
        }
      }
      return rule
    },
    customRule () {
      return {
        numberOnly (value) {
          const regNumber = /^-?\d+(\.\d+)?$/
          return {
            valid: regNumber.test(value)
          }
        },
        phone (value) {
          const regMobile = /^1[1-9]\d{9}$/
          if (value) {
            let mobile = value.split('-')
            if (regMobile.test(mobile[1])) {
              return {
                valid: true
              }
            }
          } else {
            return {
              valid: true
            }
          }
        },
        specialPhone (value) {
          const regSpecialMobile = /^\d{5,11}$/
          let mobile = value.split('-')
          if (regSpecialMobile.test(mobile[1])) {
            return {
              valid: true
            }
          }
        },
        cusEmail (value) {
          const regEmail = /^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/
          if (value) {
            if (regEmail.test(value)) {
              return {
                valid: true
              }
            }
          } else {
            return {
              valid: true
            }
          }
        }
      }
    },
    isValidity () {
      return Boolean(this.data.showQuestion)
    },
    captchaRule () {
      let rule = []
      if (this.data.is_must_answer) {
        rule.push({
          required: '请输入验证码'
        })
      }
      return rule
    },
    field () {
      return `${this.data.id}-${this.options.key}-${this.data.type}`
    }
  },
  beforeCreate () {
    // 页面进入时先清理本地缓存中的 tel，确保回显逻辑不会使用上次残留的值
    try {
      utils.storage.set('tel', '')
    } catch (err) {
      // ignore storage errors
    }
  },
  mounted () {
    initNvcMessage('MessageNVC')
    $nvcEvent.on('verifyPhone', (nvcData) => {
      this.nvcData = nvcData
    })
  },
  methods: {
    tipLabel (type) {
      const componentType = Object.keys(this.inputTypeMappingGraph).reduce((val, key) => {
        const isType = Array.isArray(this.inputTypeMappingGraph[key])
          ? this.inputTypeMappingGraph[key].includes(type)
          : this.inputTypeMappingGraph[key](type)
        if (key !== 'phone_captcha' && isType) {
          return key
        } else {
          return val
        }
      }, '')
      switch (componentType) {
        case 'common':
          return '必填'
        case 'email':
          return '请输入邮箱'
        case 'phone':
          return '请输入手机号'
        default:
          return this.data.tips
      }
    },
    getTime ($event) {
      this.dateValue = $event
    },
    /**
     * 选择国家区号
     */
    selectCountry (code) {
      this.country = code
      this.countryOpen = false
      this.phoneValue = `${this.country}-${this.inputValue}`
    },
    clickCover () {
      this.countryOpen = false
    },
    phoneInput (e) {
      let value = e.target.value
      this.cellphone = value
      this.phoneValue = `${this.country}-${value}`
      if (this.captchaValue) {
        this.phoneValue = `${this.country}-${value}-${this.captchaValue}`
      }
    },
    captchaInput (e) {
      let value = e.target.value
      const cachePhone = utils.storage.get('tel', value)
      this.phoneValue = `${this.country}-${cachePhone}-${value}`
    },
    saveTel (e) {
      let value = e.target.value
      utils.storage.set('tel', value)
      this.phoneFocus = false
    },
    async send () {
      const valid = await this.validPhone(this.phoneValue)
      if (!valid) {
        return
      }
      this.captchaSending = true

      // 获取短信验证码企业签名类型, 0 为极客时间， 1 为 infoQ
      let type = 0
      if (this.data && this.data.extra_info) {
        try {
          const extraInfo = JSON.parse(this.data.extra_info)
          if (Array.isArray(extraInfo)) {
            const found = extraInfo.find(item => item && Object.prototype.hasOwnProperty.call(item, 'type'))
              type = found && typeof found.type !== 'undefined' ? found.type : 0
          } else {
            type = extraInfo.type
          }
        } catch (err) {
          console.log(err)
        }
      }
      EventService.sendCode(
        this.country,
        this.inputValue,
        this.nvcData,
        type
      ).then(() => {
        this.captchaSended = true
        this.loopTime()
      }).catch(err => {
        const code = err.code + ''
        if (code === '-2800' || code === '-2900') {
          resetNC()

          return
        }

        if (code === '-2400') {
          $nvcEvent.setScene('verifyPhone')
          this.isNvcShow = true
          showNC && showNC()

          /** 测试人机验证代码 开始 **/
          // var params = 'a=' + window.getNVCVal()
          // nvcDemo('//cf.aliyun.com/nvc/nvcAnalyze.jsonp', params)
          /** 测试人机验证代码 结束 **/
        }
        this.captchaSending = false
        this.captchaSended = false
        this.waitTime = 60
        this.$Message.toast({
          message: err.msg || '未知错误，请稍后重试'
        })
      })
    },
    validPhone (val) {
      return new Promise((resolve, reject) => {
        const regMobile = /^1[1-9]\d{9}$/
        const regSpecialMobile = /^\d{5,11}$/
        let mobile = val.split('-')
        if (this.country + '' === '86') {
          resolve(regMobile.test(mobile[1]))
        } else {
          resolve(regSpecialMobile.test(mobile[1]))
        }
      })
    },
    loopTime () {
      if (!this.captchaSending) {
        this.waitTime = 60

        return
      }

      setTimeout(() => {
        this.waitTime--
        if (this.waitTime > 0) {
          this.loopTime()
        } else {
          this.captchaSending = false
          this.waitTime = 60
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/_common";
$default-color: #828A92;

.form-fillblank {
  & .name-form-text,
  & .phone-form-text,
  & .email-form-text,
  & .date-form-text {
    width: 49%;
  }

  & .every-form-text {
    position: relative;
    width: 100%;

    &.single-line {
      width: 100%;
    }

    & ::v-deep .gkui-form-element[data-color="gray"] {
      border-radius: 4px;

      &[gk-textarea="true"] .gkui-form-error {
        bottom: -19%;
      }
    }

    & ::v-deep .gkui-form-element[data-color="gray"] textarea {
      padding: 4px 12px;
      min-height: 110px;
      font-size: 16px;
      color: #4a4a4a;
      resize: none;
    }

    & .word-count {
      position: absolute;
      right: 18px; bottom: 3px;
      font-size: 14px; color: #828a92;
      opacity: .6;
    }
  }

  & .phone-form-text {
    display: flex;
    position: relative;
    height: 40px;

    & .area-num {
      display: flex;
      justify-content: space-between;
      position: relative;
      width: 87px;
      padding: 0 10px 0 10px;
      background: #FBFBFB;
      border: 1px solid #D9D9D9; border-radius: 3px 0 0 3px;
      border-right: 0;
      line-height: 38px;
      color: #4a4a4a;
      cursor: pointer;
      user-select: none;
      @extend %transition;

      &::after {
        content: '';
        position: absolute;
        right: 20px; top: 50%;
        width: 9px; height: 7px;
        background: url('../../../../assets/img/form/sanjiao.png') no-repeat center/cover;
        transform: translateY(-50%);
      }

      &.focus {
        border-color: #1458D4;
      }
    }

    & ::v-deep [gk-form-custom-group] {
      flex: 1;

      & .gkui-form-error {
        left: -87px; bottom: -50%;
      }

    }

    & ::v-deep [gk-form] {
      flex: 1;
      border-radius: 0 3px 3px 0;
    }

    & .phone-form-text-wrap {
      flex: 1;
      position: relative;
      height: 100%;
      border: 1px solid $grayForm;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      overflow: hidden;
      @extend %transition;

      & input {
        box-sizing: border-box;
        padding: 0 12px;
        width: 100%; height: 100%;
        border: 0;
        outline: none;
      }

      &.focus {
        border-color: #1458D4;
      }
    }

    & .country-dropdown {
      box-sizing: border-box;
      position: absolute; z-index: 10; left: 0; top: 48px;
      padding: 10px 0;
      width: 100%; max-height: 200px;
      overflow-y: auto;
      background: #ffffff;
      border: 1px solid $grayForm; border-radius: 4px;
      box-shadow: 6px 10px 16px rgba(0, 0, 0, 0.2);
      & li {
        display: flex;
        justify-content: space-between;
        padding: 0 50px 0 10px;
        @include font(16, 400);
        color: $bodyBlack; line-height: 40px;
        cursor: pointer;
        @extend %transition;

        &:hover,
        &.active {
          position: relative;
          background: $blueHoverNew;
          color: #fff;
          &::after {
            content: '';
            position: absolute;
            right: 20px; top: 18px;
            width: 11px; height: 6px;
            border-left: 2px solid #fff;
            border-bottom: 2px solid #fff;
            transform: translateY(-50%) rotate(-45deg);
          }
        }
      }
    }
  }

  & .nvc-wrap {
    width: 49%;
    margin-top: 26px;

    & ::v-deep {
      & .btn_slid {
        top: 1px;
        height: 34px;
      }

      & .errloading {
        width: 100%;
      }
    }
  }

  & .captcha-custom-group {
    &[invalid="true"] {
      & .captcha-wrap {
        border-color: #F74C3A;
      }
    }
  }

  & .captcha-wrap {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 49%; height: 40px;
    padding: 0 12px; margin: 26px 0 0;
    border: 1px solid $grayForm;
    border-radius: 3px;
    @extend %transition;

    & input {
      flex: 1;
      border: none;
      outline: none;
    }

    & .captcha.disabled {
      background: #fff;
      cursor: not-allowed;
    }

    &[data-focus] {
      border-color: $blue;
    }

    & .send-btn {
      margin-left: 10px;
      cursor: pointer;

      &:hover {
        color: $blue;
      }

      &.disabled {
        color: $gray;
        opacity: 0.6;
        // pointer-events: none;
        cursor: not-allowed;
      }
    }
  }

  .custom-group[invalid] {
    .area-num, .phone-form-text-wrap {
      border-color: #F74C3A;
    }
  }

  & .date-form-text {
    position: relative;
    & .date-icon {
      display: none;
      position: absolute;
      right: 8px; top: 6px;
      color: #4a4a4a;
    }

    & ::v-deep {
      .ivu-input-suffix {
        i {
          line-height: 38px;
        }
        .ivu-icon-ios-calendar-outline:before {
          content: '';
          position: absolute; right: 8px; top: 11px;
          width: 17px; height: 15px;
          background: url('../../../../assets/img/form/data-icon.png') no-repeat center center/cover;
        }
      }

      & .ivu-input {
        padding: 0 12px;
        height: 38px;
        background-color: #FBFBFB;
        font-size: 16px;
        color: #4a4a4a;
        box-shadow: none;
        -webkit-appearance: none;
        &:hover {
          border-color: #dcdee2;
        }
        &:focus {
          border-color: #dcdee2;
        }
        &::placeholder {
          color: #4a4a4a;
        }
      }
      & .ivu-date-picker-focused {
        & .ivu-input {
          border-color: #1458D4;
        }
      }
    }
  }
}
.cover{
  position: fixed; z-index: 10; top: 0; left: 0; right: 0; bottom: 0;
  background-color: transparent;
}
@media screen and (max-width: 768px) {
  .form-fillblank {
    & .name-form-text,
    & .phone-form-text,
    & .email-form-text,
    & .captcha-wrap,
    & .date-form-text {
      width: 100%;
    }

    & .every-form-text {
      &.single-line {
        width: 100%;
      }
    }

    & .form-address .address-wrap {
      width: auto;
    }
    & .form-address .address-wrap .input-wrap {
      width: 49%;

      &:nth-of-type(3) {
        width: 100%;
      }

      & ::v-deep .gkui-form-element .gkui-form-text {
        font-size: 14px;
      }

      & .select::after {
        right: 9px;
      }
    }

    & .form-address .select-dropdown,
    & .phone-form-text .country-dropdown {
      position: fixed;
      top: 50%; left: 50% !important;
      width: 85vw; max-height: 60vh;
      transform: translate(-50%, -50%);
      & li {
        font-size: 14px;
      }
    }
  }

  .cover {
    background-color: #000;
    opacity: .3;
    z-index: 10;
  }
}
</style>
